import { useEffect, useState, useRef } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [status, setStatus] = useState({ loading: true });
  const attempts = useRef(0);

  useEffect(() => {
    if (!sid) { setStatus({ loading: false, error: "Missing session id" }); return; }
    let cancelled = false;

    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (cancelled) return;
        if (data.payment_status === "paid") {
          setStatus({ loading: false, ...data });
          return;
        }
        if (attempts.current < 8) {
          attempts.current += 1;
          setTimeout(poll, 2000);
        } else {
          setStatus({ loading: false, ...data, timeout: true });
        }
      } catch {
        if (!cancelled) setStatus({ loading: false, error: "Could not verify" });
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [sid]);

  return (
    <div className="max-w-[720px] mx-auto px-6 md:px-10 py-20 fade-up" data-testid="payment-success-page">
      {status.loading ? (
        <>
          <div className="tag-red">Verifying</div>
          <h1 className="font-display text-5xl mt-2">Confirming your order…</h1>
          <p className="font-body mt-3">One moment while we sync with Stripe.</p>
        </>
      ) : status.payment_status === "paid" ? (
        <>
          <div className="tag-red">Paid</div>
          <h1 className="font-display text-6xl mt-2">To be very honest —<br/>thank you.</h1>
          <p className="font-body mt-4 opacity-90">
            Your order for <b>${status.amount?.toFixed(2)}</b> is confirmed. You will receive shipping updates shortly.
          </p>
          <Link to="/shop" className="btn-ink mt-8 inline-block" data-testid="success-shop-again">Keep shopping</Link>
        </>
      ) : (
        <>
          <div className="tag-red">Pending</div>
          <h1 className="font-display text-5xl mt-2">Payment is processing.</h1>
          <p className="font-body mt-3 opacity-80">Refresh in a moment or check your email for Stripe's confirmation.</p>
          <Link to="/" className="link-blue mt-6 inline-block">Return home</Link>
        </>
      )}
    </div>
  );
}
